import 'assets/css/HAGD-Custom.css';
import 'assets/css/accueil.css';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useState} from 'react';
import axios from 'components/Axios/Axios.js';
import DNS from 'components/DNS/dns.js';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import {fr, enUS} from 'react-date-range/src/locale/index';
import Moment from 'react-moment';
import {isMobile} from 'react-device-detect';
import person from 'assets/img/person1.png';
import 'assets/css/tablelist.css';
import ModalADDTableList from './modalADD';
import ModalEDITTableList from './modalEDIT';
import ModalDELETETableList from './modalDELETE';
import ModalCommentTableList from './modalComment';
import {FaCheckCircle, FaTimesCircle} from 'react-icons/fa';
import NotificationAlert from 'react-notification-alert';

// react-bootstrap components
import {
  Button,
  Card,
  Form,
  Table,
  Container,
  Row,
  Col,
} from 'react-bootstrap';
import {DateRange} from 'react-date-range';
import {CardFooter} from 'reactstrap';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';

const TableList = () => {
  const token = useSelector((state) => state.token);
  const currentBuilding = useSelector((state) => state.currentBuilding);
  const user = useSelector((state) => state.user);
  let fileInput = React.createRef(HTMLTextAreaElement);

  const {t} = useTranslation();

  const [showModal, setShowModal] = React.useState(false);
  {
    /* Modal for Create method */
  }
  const [showModal2, setShowModal2] = React.useState(false);
  {
    /* Modal for Edit method */
  }
  const [showModal3, setShowModal3] = React.useState(false);
  {
    /* Modal for Delete method */
  }
  const [showModalComments, setModalComments] = React.useState(false);
  {
    /* Modal for Comments */
  }
  const [showComments, setComments] = React.useState('');
  const [showVisitor, setVisitor] = useState('');
  const [showVisitorEmail, setVisitorEmail] = useState('');
  const [showVisitorEntreprise, setVisitorEntreprise] = useState('');
  const [showVisitorEmailRequired, setVisitorEmailRequired] = useState(false);
  const [showHour, setHour] = useState('');
  const [showDate, setDate] = useState('');
  const [showApPk, setApPk] = useState('');
  const [showVFirstName, setVFirstName] = useState('');
  const [showVLastName, setVLastName] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showTodayDate, setTodayDate] = useState('');
  const [showMaxdayDate, setMaxdayDate] = useState('');
  const [showLanguageMail, setLanguageMail] = useState('');
  const [showDisplayDateRange, setDisplayDateRange] = useState('none');
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const iconStyle = {fontSize: '20px'};
  const [alist, setList] = useState({
    data: null,
    error: false,
  });

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'token ' + token['tokenRedux'],
    },
  };
  useEffect(() => {
    console.log('LOCALSTORAGE:     ', localStorage.i18nextLng);
    getTodayDate();
    getAppointment();
    fileInput;
  }, []);

  useEffect(() => {
    const check = !!user?.user?.vip?.email;
    setVisitorEmailRequired(check);
  }, [user['user'].nameEntreprise]);

  const resetValues = () => {
    setHour('');
    setDate('');
    setVisitor('');
    setVisitorEmail('');
    setVisitorEntreprise('');
    setVFirstName('');
    setLanguageMail('');
    setVLastName('');
    setComments('');
    setApPk('');
  };

  const getTodayDate = () => {
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();

    today = yyyy + '-' + mm + '-' + dd;
    const maxday = yyyy + 1 + '-' + mm + '-' + dd;

    setTodayDate(today);
    setMaxdayDate(maxday);
  };

  const getAppointment = (stateVar = state) => {
    const day = stateVar[0].startDate.getDate();
    const monthIndex = stateVar[0].startDate.getMonth();
    const year = stateVar[0].startDate.getFullYear();
    const myFormattedDate =
      year +
      '-' +
      (monthIndex + 1 >= 10 ? monthIndex + 1 : '0' + (monthIndex + 1)) +
      '-' +
      day;
    const day2 = stateVar[0].endDate.getDate();
    const monthIndex2 = stateVar[0].endDate.getMonth();
    const year2 = stateVar[0].endDate.getFullYear();
    const myFormattedDate2 =
      year2 +
      '-' +
      (monthIndex2 + 1 >= 10 ? monthIndex2 + 1 : '0' + (monthIndex2 + 1)) +
      '-' +
      day2;
    console.log(
        'myFormattedDate',
        myFormattedDate,
        '=>',
        'myFormattedDate2',
        myFormattedDate2,
    );
    if (myFormattedDate == myFormattedDate2) {
      fetch(
          DNS +
          '/list/deleteGetPatchAppointment/' +
          currentBuilding['currentbuildingRedux'].pk +
          '/' +
          '?start=' +
          myFormattedDate,
          requestOptions,
      ).then(async (response) => {
        const data = await response.json();
        console.log('NUIZAEHGDFKUIYAZHKFJHGZ!', data);
        if (data.fields) {
          setList({
            data: data.fields,
            error: false,
          });
          return;
        } else {
          setList({
            data: data.fields,
            error: false,
          });
          return;
        }
      });
    } else {
      fetch(
          DNS +
          '/list/deleteGetPatchAppointment/' +
          currentBuilding['currentbuildingRedux'].pk +
          '/' +
          '?start=' +
          myFormattedDate +
          '&end=' +
          myFormattedDate2,
          requestOptions,
      ).then(async (response) => {
        const data = await response.json();
        if (data.fields) {
          setList({
            data: data.fields,
            error: false,
          });
          return;
        } else {
          setList({
            data: data.fields,
            error: false,
          });
          return;
        }
      });
    }
  };

  const handleSubmission2 = (event) => {
    const formData = new FormData();

    formData.append('excel_file', event.target.files[0]);
    const requestOptions = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'token ' + token['tokenRedux'],
      },
    };

    axios
        .post(
            DNS +
          '/list/exceloption/' +
          currentBuilding['currentbuildingRedux'].pk +
          '/',
            formData,
            requestOptions,
        )
        .then((response) => {
        // eslint-disable-next-line
        notify(
              'tc',
              'L\'excel des rendez-vous a bien été importé.',
              'success',
              'nc-icon nc-check-2',
          );
          getAppointment();
        })
        .catch((error) => {
          resetValues();
          notify(
              'tc',
              'Une erreur est survenue, veuillez réessayer ultérieurement.',
              'danger',
              'nc-icon nc-simple-remove',
          );
        });
  };

  // const handleSubmission = (event) => {
  //   const formData = new FormData();

  //   formData.append('excel_file', event.target.files[0]);
  //   const requestOptions = {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //       'Authorization': 'token ' + token['tokenRedux'],
  //     },
  //   };

  //   axios
  //       .post(
  //           DNS +
  //         '/list/exceloption/' +
  //         currentBuilding['currentbuildingRedux'].pk +
  //         '/',
  //           formData,
  //           requestOptions,
  //       )
  //       .then((response) => {
  //         console.log('OK');
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  // };

  let content = null;

  if (alist.error) {
    content = <p>ERROR: couldn't load appointment list properly.</p>;
  }

  const listFilter = [];

  if (alist.data) {
    const data = alist.data.slice(0).filter((val) => {
      if (
        (user['user'].role != 'collab' && user['user'].role != 'superCollab') ||
        (user['user'].role == 'collab' &&
          val.email.toLowerCase().includes(user['user'].email.toLowerCase())) ||
        (user['user'].role == 'superCollab' &&
          val.email.toLowerCase().includes(user['user'].email.toLowerCase()))
      ) {
        if (searchTerm == '') {
          listFilter.push(val);
          return val;
        } else if (
          val.visitor.toLowerCase().includes(searchTerm.toLowerCase())
        ) {
          listFilter.push(val);
          return val;
        } else if (val.time.toLowerCase().includes(searchTerm.toLowerCase())) {
          listFilter.push(val);
          return val;
        } else if (val.name.toLowerCase().includes(searchTerm.toLowerCase())) {
          listFilter.concat(val);
          return val;
        } else if (
          val.companyName.toLowerCase().includes(searchTerm.toLowerCase())
        ) {
          listFilter.push(val);
          return val;
        } else if (val.email.toLowerCase().includes(searchTerm.toLowerCase())) {
          listFilter.push(val);
          return val;
        }
      }
    });

    if (data.length > 0) {
      content = data.map((appointment, key) => {
        if (!isMobile) {
          return (
            <tr id="pk" value={appointment.pk} key={key}>
              <td>{appointment.visitor}</td>
              <td>{appointment.time}</td>
              <td>
                <Moment format="DD/MM/YYYY">{appointment.date}</Moment>
              </td>
              <td>{appointment.name}</td>
              <td>
                {appointment.appointmentStatus == 'done' ? (
                  <a className="status"> {t(translations.CHECKIN_STATUS1)}</a>
                ) : appointment.appointmentStatus == 'waiting' ? (
                  <a className="status"> {t(translations.CHECKIN_STATUS2)}</a>
                ) : appointment.appointmentStatus == 'missed' ? (
                  <a className="status"> {t(translations.CHECKIN_STATUS3)}</a>
                ) : (
                  <a className="status"> {t(translations.CHECKIN_STATUS4)}</a>
                )}
              </td>
              <td>{appointment.companyName}</td>
              <td>{appointment.email}</td>
              <td>{appointment.visitor_entreprise}</td>
              {showVisitorEmailRequired == true ? (
                <td>{appointment.visitor_email}</td>
              ) : null}

              <td className="text-center">
                {appointment.commentaire == 'commentaire' ||
                appointment.commentaire == '' ? (
                  <a className="btn-sm ml-1 mr-1  btn-secondary">
                    <i className="fas fa-comment"></i>
                  </a>
                ) : (
                  <a
                    className="btn-sm btn-warning"
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                      setModalComments(true);
                      setVisitor(appointment.visitor);
                      setDate(appointment.date);
                      setHour(appointment.time);
                      setComments(appointment.commentaire);
                      setVisitorEmail(appointment.visitor_email);
                      setVisitorEntreprise(appointment.visitor_entreprise);
                    }}
                  >
                    <i className="fas fa-comment"></i>
                  </a>
                )}
              </td>
              {showVisitorEmailRequired == true && appointment.dna_status ? (
                <td className="text-center">
                  <FaCheckCircle style={{...iconStyle, color: 'green'}} />
                </td>
              ) : null}
              {showVisitorEmailRequired == true && !appointment.dna_status ? (
                <td className="text-center">
                  <FaTimesCircle style={{...iconStyle, color: 'red'}} />
                </td>
              ) : null}
              <td className="text-center">
                <a
                  className="btn-sm btn-warning"
                  style={{cursor: 'pointer'}}
                  onClick={() => {
                    setShowModal2(true);
                    setApPk(appointment.pk);
                    setVisitor(appointment.visitor);
                    setVisitorEmail(appointment.visitor_email);
                    setVisitorEntreprise(appointment.visitor_entreprise);
                    if (appointment.language_mail === 'fr') {
                      setLanguageMail({
                        value: 'fr',
                        label: t(translations.LANGUAGE_MAIL_FR),
                      });
                    } else if (appointment.language_mail === 'en') {
                      setLanguageMail({
                        value: 'en',
                        label: t(translations.LANGUAGE_MAIL_EN),
                      });
                    }
                    setVFirstName(appointment.visitor.split(' ')[1]);
                    setVLastName(appointment.visitor.split(' ')[0]);
                    setDate(appointment.date);
                    setHour(appointment.time);
                    setComments(appointment.commentaire);
                  }}
                >
                  <i className="fas fa-edit"></i>
                </a>
              </td>

              <td className="text-center">
                <a
                  className="btn-sm btn-warning"
                  style={{cursor: 'pointer'}}
                  onClick={() => {
                    setShowModal3(true);
                    setApPk(appointment.pk);
                    setVisitor(appointment.visitor);
                    setVisitorEmail(appointment.visitor_email);
                    setVisitorEntreprise(appointment.visitor_entreprise);
                    setDate(appointment.date);
                    setHour(appointment.time);
                  }}
                >
                  <i className="fas fa-times"></i>
                </a>
              </td>

              <td style={{display: 'none'}}></td>
            </tr>
          );
        } else {
          return (
            <>
              <div className="card" id="pk" value={appointment.pk} key={key}>
                <div className="row justify-content-start px-3">
                  <div className="image-bg mr-3">
                    <img className="user-img fit-image" src={person} />
                  </div>
                  <div className="offset-4 position-absolute">
                    <h2 className={'nameAppointment'}>{appointment.visitor}</h2>
                    <h6 className={'dateAppointment'}>
                      <i className="fa fa-calendar" aria-hidden="true"></i>{' '}
                      <Moment format="DD/MM/YYYY">{appointment.date}</Moment> à{' '}
                      {appointment.time}
                    </h6>
                    <h6 className={'dateAppointment'}>
                      <i className="fa fa-envelope"></i> {appointment.email}
                    </h6>
                    <h6 className={'dateAppointment'}>
                      <i className="fa fa-envelope"></i>{' '}
                      {appointment.visitor_email}
                    </h6>
                    <h6 className={'dateAppointment'}>
                      <i className="fa fa-info-circle"></i>{' '}
                      {appointment.appointmentStatus == 'done' ? (
                        <a className="status">
                          {' '}
                          {t(translations.CHECKIN_STATUS1)}
                        </a>
                      ) : appointment.appointmentStatus == 'waiting' ? (
                        <a className="status">
                          {' '}
                          {t(translations.CHECKIN_STATUS2)}
                        </a>
                      ) : appointment.appointmentStatus == 'missed' ? (
                        <a className="status">
                          {' '}
                          {t(translations.CHECKIN_STATUS3)}
                        </a>
                      ) : (
                        <a className="status">
                          {' '}
                          {t(translations.CHECKIN_STATUS4)}
                        </a>
                      )}
                    </h6>

                    <div
                      className="btn btn-yellow btn-sm btn-warning"
                      style={{cursor: 'pointer'}}
                      onClick={() => {
                        setModalComments(true);
                        setVisitor(appointment.visitor);
                        setDate(appointment.date);
                        setHour(appointment.time);
                        setComments(appointment.commentaire);
                        setVisitorEmail(appointment.visitor_email);
                        setVisitorEntreprise(appointment.visitor_entreprise);
                      }}
                    >
                      <i className="fas fa-comment"></i>
                    </div>

                    <div
                      className="btn btn-yellow btn-sm btn-warning ml-3"
                      style={{cursor: 'pointer'}}
                      onClick={() => {
                        setShowModal2(true);
                        setApPk(appointment.pk);
                        setVisitor(appointment.visitor);
                        setVisitorEmail(appointment.visitor_email);
                        setVisitorEntreprise(appointment.visitor_entreprise);
                        if (appointment.language_mail === 'fr') {
                          setLanguageMail({
                            value: 'fr',
                            label: t(translations.LANGUAGE_MAIL_FR),
                          });
                        } else if (appointment.language_mail === 'en') {
                          setLanguageMail({
                            value: 'en',
                            label: t(translations.LANGUAGE_MAIL_EN),
                          });
                        }
                        setVFirstName(appointment.visitor.split(' ')[1]);
                        setVLastName(appointment.visitor.split(' ')[0]);
                        setDate(appointment.date);
                        setHour(appointment.time);
                        setComments(appointment.commentaire);
                      }}
                    >
                      <i className="fas fa-edit"></i>
                    </div>

                    <div
                      className="btn btn-yellow btn-sm btn-warning ml-3"
                      style={{cursor: 'pointer'}}
                      onClick={() => {
                        setShowModal3(true);
                        setApPk(appointment.pk);
                        setVisitor(appointment.visitor);
                        setVisitorEmail(appointment.visitor_email);
                        setVisitorEntreprise(appointment.visitor_entreprise);
                        setDate(appointment.date);
                        setHour(appointment.time);
                      }}
                    >
                      <i className="fas fa-times"></i>
                    </div>
                  </div>
                </div>
                <div className="line"></div>
              </div>
            </>
          );
        }
      });
    } else {
      // No Appointment
      content = isMobile ? (
        <CardFooter className="text-center m-auto">
          <h4 className={'dateAppointment'}>
            <i className="fa fa-calendar" aria-hidden="true"></i>
          </h4>
          <h5 style={{fontStyle: 'CeraPro'}}>
            {t(translations.APPOINTMENT_SUBTITLE3)}
          </h5>
        </CardFooter>
      ) : null;
    }
  }

  const notificationAlertRef = React.useRef(null);
  const notify = (place, txt, typeNot, iconNot) => {
    const type = typeNot;
    let options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            <p>{txt}</p>
          </div>
        </div>
      ),
      type: type,
      icon: iconNot,
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  return (
    <Container fluid>
      <NotificationAlert ref={notificationAlertRef} />
      <ModalADDTableList
        showModal={showModal}
        setShowModal={setShowModal}
        showTodayDate={showTodayDate}
        showMaxdayDate={showMaxdayDate}
        getAppointment={getAppointment}
        showVisitorEmailRequired={showVisitorEmailRequired}
      />
      <ModalCommentTableList
        showModal={showModalComments}
        setShowModal={setModalComments}
        showComments={showComments}
        showVisitor={showVisitor}
        showDate={new Date(showDate)}
        showHour={showHour}
      />
      <ModalEDITTableList
        showModalValue={showModal2}
        setShowModal={setShowModal2}
        showTodayDate={showTodayDate}
        showMaxdayDate={showMaxdayDate}
        getAppointment={getAppointment}
        showApPk={showApPk}
        showDate={showDate}
        setDate={setDate}
        showHour={showHour}
        setHour={setHour}
        showVFirstName={showVFirstName}
        setVFirstName={setVFirstName}
        showVLastName={showVLastName}
        setVLastName={setVLastName}
        showLanguageMail={showLanguageMail}
        setLanguageMail={setLanguageMail}
        showComments={showComments}
        setComments={setComments}
        showVisitorEmail={showVisitorEmail}
        setVisitorEmail={setVisitorEmail}
        showVisitorEmailRequired={showVisitorEmailRequired}
        showVisitorEntreprise={showVisitorEntreprise}
        setVisitorEntreprise={setVisitorEntreprise}
      />
      <ModalDELETETableList
        showModal={showModal3}
        setShowModal={setShowModal3}
        getAppointment={getAppointment}
        appointmentpk={showApPk}
        showDate={showDate}
        showHour={showHour}
        showVisitor={showVisitor}
      />
      <Row className="px-0 py-0">
        <Col>
          <Card className="strpied-tabled-with-hover">
            <Card.Header>
              {!isMobile ? (
                <Card.Title as="h4">
                  {t(translations.APPOINTMENT_BLOCK_TITLE)}
                </Card.Title>
              ) : (
                <Card.Title as="h4" className={'text-center'}>
                  {t(translations.APPOINTMENT_BLOCK_TITLE)}
                </Card.Title>
              )}
              <p className="card-category d-none d-sm-block">
                {t(translations.APPOINTMENT_SUBTITLE2)}
              </p>
              <div className="row pl-0 pr-0" style={{paddingTop: '15px'}}>
                <div style={{textAlign: 'center'}}>
                  <Button
                    id="import-button"
                    className={'btn-round btn-warning mr-1'}
                    onClick={() => {
                      fileInput.click();
                    }}
                  >
                    {t(translations.EXCEL_IMPORT)}
                  </Button>{' '}
                  <Form.Control
                    type="file"
                    value={''}
                    onChange={handleSubmission2}
                    ref={(ref) => (fileInput = ref)}
                    hidden
                  />
                </div>
                <Button
                  id="Ajouter"
                  className={
                    'col-sm-12 col-12 col-md-3 col-lg-3 mr-3 pl-0 pr-0'
                  }
                  onClick={() => {
                    setShowModal(true);
                    resetValues();
                  }}
                >
                  {t(translations.APPOINTMENT_ADD_BUTTON)}
                </Button>{' '}
                {showDisplayDateRange == 'none' ? (
                  <Button
                    className={
                      'col-sm-12 col-12 col-md-3 col-lg-3 pl-0 pr-0  mr-3'
                    }
                    onClick={() => setDisplayDateRange('block')}
                  >
                    {t(translations.DATE_BUTTON_OPEN)}
                  </Button>
                ) : (
                  <Button
                    className={
                      'col-sm-12 col-12 col-md-3 col-lg-3 pl-0 pr-0 mr-3'
                    }
                    onClick={() => setDisplayDateRange('none')}
                  >
                    {t(translations.DATE_BUTTON_CLOSE)}
                  </Button>
                )}
                <div id="dateRange" style={{display: showDisplayDateRange}}>
                  <DateRange
                    editableDateInputs={true}
                    onChange={(item) => {
                      setState([item.selection]);
                      getAppointment([item.selection]);
                    }}
                    moveRangeOnFirstSelection={false}
                    ranges={state}
                    openCalendarOnFocus={false}
                    dateDisplayFormat="dd MMM yyyy"
                    locale={localStorage.i18nextLng == 'fr' ? fr : enUS}
                  />
                </div>
                <div id="custom-search-input">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control col-sm-12 col-12"
                      placeholder={t(translations.SEARCH)}
                      onChange={(event) => {
                        setSearchTerm(event.target.value);
                      }}
                    />
                    <span className="input-group-btn btn btn-primary">
                      <span className=" fas fa-search"></span>
                    </span>
                  </div>
                </div>
              </div>
            </Card.Header>
            {!isMobile ? (
              <Card.Body className="table-full-width table-responsive">
                <Table className="table-hover table-striped">
                  <thead>
                    <tr>
                      <th className="border-0">{t(translations.VISITOR)}</th>
                      <th className="border-0">{t(translations.TIME)}</th>
                      <th className="border-0">{t(translations.DATE)}</th>
                      <th className="border-0">{t(translations.RESIDENT)}</th>
                      <th className="border-0">{t(translations.CHECKIN)}</th>
                      <th className="border-0">
                        {t(translations.COMPANY_NAME)}
                      </th>
                      <th className="border-0">{t(translations.EMAIL)}</th>
                      <th className="border-0">
                        {t(translations.VISITOR_ENTREPRISE)}
                      </th>
                      {showVisitorEmailRequired == true ? (
                        <th className="border-0">
                          {t(translations.VISITOR_EMAIL)}
                        </th>
                      ) : null}
                      <th className="border-0">{t(translations.COMMENTARY)}</th>
                      {showVisitorEmailRequired == true ? (
                        <th className="border-0">
                          {t(translations.NDA_STATUS)}
                        </th>
                      ) : null}
                      <th className="border-0">{t(translations.EDIT)}</th>
                      <th className="border-0">{t(translations.DELETE)}</th>
                    </tr>
                  </thead>
                  <tbody>{content}</tbody>
                </Table>
              </Card.Body>
            ) : (
              <Card.Body style={{padding: 0}}>{content}</Card.Body>
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default TableList;
